import * as React from 'react'
import toast from 'react-hot-toast'
import { removeFormObject } from '../../../handlers/formDataHandler.ts'
import { dataState } from '../../../store/dataState.ts'
import { IPet } from '../../../interfaces/types.ts'
import { AsyncButton } from '../AsyncButton/AsyncButton.tsx'
import { PopupPortal } from '../Popup/PopupPortal.tsx'

interface Props {
    pet: IPet
    open: boolean
    setOpen: (o: boolean) => void
}

export const RemovePet: React.FC<Props> = (props) => {
    const {pet, open, setOpen} = props
    
    const device = dataState.devices.find(d => d.petId === pet?._id)
    
    const sendCommand = async () => {
        try {
            const responseData = await removeFormObject('pet', pet?._id)
            setOpen(false)
            if (responseData) {
                dataState.pets = (responseData)
                toast.success('Pet removed')
            } else {
                toast.error('Error, remove failed, try again later.')
            }
        } catch (e) {
            // TODO: handle error
            toast.error('Fatal error, remove failed try again later.')
            setOpen(false)
        }
    }
    
    const cancel = () => {
        setOpen(false)
    }
    
    const panelHeader = (
        <div className={'prose flex flex-col justify-start items-center gap-2'}>
            <h2 className={'mt-0 mb-0 text-primary'}>Remove Pet</h2>
        </div>
    )
    
    const howDeviceIsHandled = device ?
        <div className={'text-left'}>
            <div className={'prose text-lg p-2'}>
                The Gibi Tracker <b>{device.deviceName}</b> will be unassigned from <b>{pet?.petName}</b>.
                <br/><br/>
                This will not affect the subscription associated with {device.deviceName}.
                However, Tracker functionality will be limited until paired with another pet.
            </div>
        </div>
        : null
    
    const panel = (
        <div className={'flex flex-col justify-start items-center gap-2 h-full p-4 w-full'}>
            {panelHeader}
            <div className={'text-neutral-content flex flex-col justify-start items-center gap-4'}>
                <div className={'font-semibold text-center text-lg w-full'}>
                    Are you sure you want to remove {pet?.petName}?
                </div>
                {howDeviceIsHandled}
                <article className={'text-center text-accent'}>
                    This action cannot be undone.
                </article>
            </div>
        </div>
    )
    
    const buttons = (
        <div className={'p-4 flex justify-between items-center w-full'}>
            <button className={'btn btn-secondary btn-ghost text-secondary btn-sm'} onClick={cancel}>Cancel</button>
            <AsyncButton classNames={'btn btn-outlined btn-secondary btn-sm'} onClick={sendCommand}
                         disabled={false}>Remove</AsyncButton>
        </div>
    )
    
    const popUp = (
        <PopupPortal open={open}>
            {panel}
            {buttons}
        </PopupPortal>
    )
    
    return (<>
        {popUp}
    </>)
}
